export enum DropzoneModeType {
	INNER = "INNER",
	OUTER = "OUTER"
}
